import React from 'react';
import CTASection from '../components/CTASection';
import SEOMetaTags from '../components/SEOMetaTags';
import usePageTitle from '../hooks/usePageTitle';

const Financing = () => {
    usePageTitle('financing');

    return (
        <>
            <SEOMetaTags pageKey="financing" />
            {/* Section - Inner Page Headline Start */}
            <div className="mxd-section mxd-section-inner-headline padding-text-pre-block">
                <div className="mxd-container grid-container">
                    <div className="mxd-block loading-wrap">
                        <div className="container-fluid px-0">
                            <div className="row gx-0">
                                <div className="col-12 col-xl-2 mxd-grid-item no-margin">
                                    <div className="mxd-block__name name-inner-headline loading__item">
                                        <p className="mxd-point-subtitle">
                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                                width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill="currentColor" d="M19.6,9.6c0,0-3,0-4,0c-0.4,0-1.8-0.2-1.8-0.2c-0.6-0.1-1.1-0.2-1.6-0.6c-0.5-0.3-0.9-0.8-1.2-1.2
                        c-0.3-0.4-0.4-0.9-0.5-1.4c0,0-0.1-1.1-0.2-1.5c-0.1-1.1,0-4.4,0-4.4C10.4,0.2,10.2,0,10,0S9.6,0.2,9.6,0.4c0,0,0.1,3.3,0,4.4
                        c0,0.4-0.2,1.5-0.2,1.5C9.4,6.7,9.2,7.2,9,7.6C8.7,8.1,8.2,8.5,7.8,8.9c-0.5,0.3-1,0.5-1.6,0.6c0,0-1.2,0.1-1.7,0.2
                        c-1,0.1-4.2,0-4.2,0C0.2,9.6,0,9.8,0,10c0,0.2,0.2,0.4,0.4,0.4c0,0,3.1-0.1,4.2,0c0.4,0,1.7,0.2,1.7,0.2c0.6,0.1,1.1,0.2,1.6,0.6
                        c0.4,0.3,0.8,0.7,1.1,1.1c0.3,0.5,0.5,1,0.6,1.6c0,0,0.1,1.3,0.2,1.7c0,1,0,4.1,0,4.1c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4
                        c0,0,0-3.1,0-4.1c0-0.4,0.2-1.7,0.2-1.7c0.1-0.6,0.2-1.1,0.6-1.6c0.3-0.4,0.7-0.8,1.1-1.1c0.5-0.3,1-0.5,1.6-0.6
                        c0,0,1.3-0.1,1.8-0.2c1,0,4,0,4,0c0.2,0,0.4-0.2,0.4-0.4C20,9.8,19.8,9.6,19.6,9.6L19.6,9.6z" />
                                            </svg>
                                            <span>Financiación</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-8 mxd-grid-item no-margin">
                                    <div className="mxd-block__content">
                                        <div className="mxd-block__inner-headline">
                                            <h1 className="inner-headline__title animated-type loading__item">
                                                <span id="typed-strings">
                                                    <b>Hipotecas</b>
                                                    <b>Préstamos</b>
                                                    <b>Asesoría</b>
                                                </span>
                                                <span id="typed"></span>
                                            </h1>
                            <p className="inner-headline__text t-large t-bright loading__item">¿Estás
                                                pensando pedir una hipoteca para comprar tu próxima propiedad? En 3claus
                                                queremos acompañarte en cada paso. Te mostramos las mejores alternativas de
                                                financiación inmobiliaria y préstamos con las mejores condiciones del
                                                mercado.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Section - Inner Page Headline End */}

            {/* Section - Services Start */}
            <div className="mxd-section padding-pre-grid">
                <div className="mxd-container grid-container">
                    <div className="mxd-block">
                        <div className="mxd-section-title">
                            <div className="container-fluid p-0">
                                <div className="row g-0">
                                    <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                        <div className="mxd-section-title__hrtitle">
                                            <h2 className="reveal-type">Asesoría en hipotecas y préstamos</h2>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                        <div className="mxd-section-title__hrdescr">
                                            <p className="anim-uni-in-up">La adquisición de una nueva propiedad es un gran paso,
                                                estamos comprometidos con ofrecer servicios de asesoría inmobiliaria de alto
                                                nivel. Te damos los mejores consejos financieros para que tomes la mejor
                                                decisión en tu próxima inversión.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Section - Services End */}

            {/* Section - Services List Start */}
            <div className="mxd-section padding-default">
                <div className="mxd-container grid-container">
                    <div className="mxd-block">
                        <div className="mxd-approach-list">
                            <div className="mxd-approach-list__item">
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                                <div className="mxd-approach-list__inner">
                                    <div className="container-fluid px-0">
                                        <div className="row gx-0">
                                            <div className="col-12 col-xl-2 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__image anim-uni-in-up">
                                                    {/*<img src="https://dummyimage.com/100x100/4d4d4d/838383" alt="Icon" />*/}
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-4 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__title anim-uni-in-up">
                                                    <h6>Comparación de ofertas</h6>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__descr anim-uni-in-up">
                                                    <p>Como asesores inmobiliarios nos encargamos de hacer la comparación de
                                                        ofertas bancarias, informar a nuestros clientes la amplia gama de
                                                        opciones de préstamos e hipotecas de las diversas entidades
                                                        financieras.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                            </div>
                            <div className="mxd-approach-list__item">
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                                <div className="mxd-approach-list__inner">
                                    <div className="container-fluid px-0">
                                        <div className="row gx-0">
                                            <div className="col-12 col-xl-2 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__image anim-uni-in-up">
                                                    {/*<img src="https://dummyimage.com/100x100/4d4d4d/838383" alt="Icon" />*/}
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-4 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__title anim-uni-in-up">
                                                    <h6>Tasas de interés</h6>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__descr anim-uni-in-up">
                                                    <p>Estos porcentajes pueden ser fijos, variables y mixtos, dependiendo
                                                        del banco o la entidad financiera. Nuestro trabajo es informar de
                                                        forma clara cómo cada uno de estos puede afectar la cuota anual.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                            </div>
                            <div className="mxd-approach-list__item">
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                                <div className="mxd-approach-list__inner">
                                    <div className="container-fluid px-0">
                                        <div className="row gx-0">
                                            <div className="col-12 col-xl-2 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__image anim-uni-in-up">
                                                    {/*<img src="https://dummyimage.com/100x100/4d4d4d/838383" alt="Icon" />*/}
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-4 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__title anim-uni-in-up">
                                                    <h6>Plazos de pago</h6>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__descr anim-uni-in-up">
                                                    <p>Se refiere al tiempo que tendrá el solicitante para devolver el
                                                        préstamo, el cual puede ser variable según cada perfil y por
                                                        supuesto, del banco, pero suele extenderse entre 15 a 30 años en
                                                        pagos mensuales.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Section - Services List End */}

            {/* Section - Process Start */}
            <div className="mxd-section padding-default">
                <div className="mxd-container grid-container">
                    <div className="mxd-block">
                        <div className="mxd-pinned-universal">
                            <div className="container-fluid px-0">
                                <div className="row gx-0">
                                    <div className="col-12 col-xl-5 mxd-pinned-universal__static">
                                        <div className="mxd-pinned-universal__static-inner no-margin">
                                            <div className="mxd-section-title h2-only no-margin-desktop">
                                                <div className="container-fluid p-0">
                                                    <div className="row g-0">
                                                        <div className="col-12 mxd-grid-item no-margin">
                                                            <div className="mxd-section-title__title card-split-title">
                                                                <h2 className="reveal-type">¿Qué hacemos<br />por ti?</h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-7 mxd-pinned-universal__scroll">
                                        <div className="mxd-pinned-universal__scroll-inner mxd-grid-item no-margin">
                                            <div className="mxd-res-list">
                                                <div className="mxd-res-list__item">
                                                    <div className="mxd-res-list__divider anim-uni-in-up"></div>
                                                    <div className="mxd-res-list__content">
                                                        <div className="mxd-res-list__data">
                                                            <div className="mxd-res-list__title">
                                                                <h4 className="anim-uni-in-up">Recopilamos la documentación</h4>
                                                            </div>
                                                            <div className="mxd-res-list__descr">
                                                                <p className="anim-uni-in-up">Te ayudamos a reunir todos los
                                                                    documentos necesarios para tu solicitud de hipoteca.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mxd-res-list__divider anim-uni-in-up"></div>
                                                </div>
                                                <div className="mxd-res-list__item">
                                                    <div className="mxd-res-list__divider anim-uni-in-up"></div>
                                                    <div className="mxd-res-list__content">
                                                        <div className="mxd-res-list__data">
                                                            <div className="mxd-res-list__title">
                                                                <h4 className="anim-uni-in-up">Recomendamos bancos</h4>
                                                            </div>
                                                            <div className="mxd-res-list__descr">
                                                                <p className="anim-uni-in-up">Te recomendamos bancos y entidades
                                                                    financieras que más se adaptan a tu perfil.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mxd-res-list__divider anim-uni-in-up"></div>
                                                </div>
                                                <div className="mxd-res-list__item">
                                                    <div className="mxd-res-list__divider anim-uni-in-up"></div>
                                                    <div className="mxd-res-list__content">
                                                        <div className="mxd-res-list__data">
                                                            <div className="mxd-res-list__title">
                                                                <h4 className="anim-uni-in-up">Mediamos y negociamos</h4>
                                                            </div>
                                                            <div className="mxd-res-list__descr">
                                                                <p className="anim-uni-in-up">Mediamos y negociamos las
                                                                    condiciones de la hipoteca para conseguir las mejores
                                                                    condiciones.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mxd-res-list__divider anim-uni-in-up"></div>
                                                </div>
                                                <div className="mxd-res-list__item">
                                                    <div className="mxd-res-list__divider anim-uni-in-up"></div>
                                                    <div className="mxd-res-list__content">
                                                        <div className="mxd-res-list__data">
                                                            <div className="mxd-res-list__title">
                                                                <h4 className="anim-uni-in-up">Identificamos los riesgos</h4>
                                                            </div>
                                                            <div className="mxd-res-list__descr">
                                                                <p className="anim-uni-in-up">Hacemos un previo análisis
                                                                    crediticio para reconocer posibles complicaciones y
                                                                    evitar que la solicitud sea rechazada.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mxd-res-list__divider anim-uni-in-up"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Section - Process End */}

            {/* Section - CTA Start */}
            <CTASection
                title="¿Tienes alguna pregunta?"
                description="Estaremos encantados de ayudarte sin ningún compromiso, contacta con nosotros y haremos lo posible :)"
                buttonText="Pregúntanos algo"
                icon="ph-bold ph-question"
                iconType="icon"
            />
            {/* Section - CTA End */}
        </>
    );
};

export default Financing;
